export const isSuccessResponse = (status: number) => {
  if (status > 199 && status < 300) return true;
  return false;
};
